import ContactPreview from './ContactPreview';

export default ContactPreview;
